import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["findEmailQuestion", "crmQuestion", "crmSelect"]

  updateQuestions() {
    // Display the question about how to find emails
    if (document.querySelector("input[name='user[product_intent]']:checked")?.value === "find_emails") {
      this.findEmailQuestionTarget.classList.remove("d-none")
    } else {
      this.findEmailQuestionTarget.classList.add("d-none")
    }

    // Display the question to select a CRM
    if (document.querySelector("input[name='has_crm']:checked")?.value === "yes") {
      this.crmQuestionTarget.classList.remove("d-none")
    } else {
      this.crmQuestionTarget.classList.add("d-none")
    }
  }

  validateForm(e) {
    let isValid = false

    if (
      document.querySelector("input[name='user[product_intent]']:checked")?.value === "find_emails" &&
      typeof document.querySelector("input[name='user[email_search_intent]']:checked")?.value === "undefined"
    ) {
      App.displayFlash("danger", "Please indicate how you would like to find email addresses")
    } else if (
      document.querySelector("input[name='has_crm']:checked")?.value === "yes" &&
      this.crmSelectTarget[this.crmSelectTarget.selectedIndex].value === ""
    ) {
      App.displayFlash("danger", "Please indicate what CRM you're using")
    } else if (typeof document.querySelector("input[name='user[product_intent]']:checked")?.value === "undefined") {
      App.displayFlash("danger", "Please select what you want to primarily use Hunter for")
    } else {
      isValid = true
    }

    if (!isValid) {
      e.preventDefault()

      setTimeout(function () {
        App.enableForm()
      }, 100)
    }
  }
}
